import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * Handles the URL fragment (#session_id=...) returned by Emergent Google Auth.
 * Exchanges the session_id for a session_token cookie, then redirects to workspace.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const { exchangeSessionId } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    // clean the fragment immediately so refreshing won't reprocess
    window.history.replaceState(null, "", window.location.pathname);

    exchangeSessionId(sessionId)
      .then((user) => {
        nav("/workspace", { replace: true, state: { user } });
      })
      .catch((e) => {
        setError(e?.response?.data?.detail || e.message || "Sign-in failed");
      });
  }, [exchangeSessionId, nav]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAFAF7] text-slate-900">
      {error ? (
        <div className="text-center">
          <div className="overline mb-2 text-red-400">SIGN-IN ERROR</div>
          <div className="text-sm text-slate-600">{error}</div>
          <button
            onClick={() => nav("/")}
            className="mt-4 border border-slate-200 px-4 py-2 text-xs hover:border-slate-300"
          >
            Return home
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-3 text-slate-600">
          <Loader2 className="h-5 w-5 animate-spin" />
          <span className="overline">FINISHING SIGN-IN…</span>
        </div>
      )}
    </div>
  );
}
